const firebaseConfig = {
  apiKey: "AIzaSyAvREkVpJ7VnrCgfgSYuWCGC1Rn0sNWIio",
  authDomain: "chatbot-login-25188.firebaseapp.com",
  projectId: "chatbot-login-25188",
  storageBucket: "chatbot-login-25188.appspot.com",
  messagingSenderId: "824992711558",
  appId: "1:824992711558:web:ba9b29bd6aff1021136207"
};

export default firebaseConfig;